/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 13:52 22.04.2023
 * @ Description: class permettant de géré les mots des phrase
 */


export default class Word{
    constructor(text,startPos,endPos){
        this.text=text;
        this.startPos=startPos;
        this.endPos=endPos;
    }
}